/**
 * sessionPoller — 短轮询引擎(纯逻辑, 可移植)。
 * 基座: 前端权益刷新设计 §4
 * 间隔拉取 session, 命中预期 plan 即停, 超时转"处理中"提示。
 */
import type { PollConfig, SessionSnapshot } from "./refreshTypes";

export interface PollerHandle {
	stop: () => void;
}

/**
 * 启动轮询。check 返回 true 表示命中(停止轮询+onSuccess), 全部超时则 onTimeout。
 */
export function startSessionPoller(options: {
	config: PollConfig;
	fetchSession: () => Promise<SessionSnapshot | null>;
	check: (session: SessionSnapshot) => boolean;
	onSuccess: (session: SessionSnapshot) => void | Promise<void>;
	onTimeout: () => void;
}): PollerHandle {
	let attempts = 0;
	let stopped = false;
	let timer: ReturnType<typeof setTimeout> | null = null;

	const tick = async () => {
		if (stopped) return;
		attempts++;
		try {
			const session = await options.fetchSession();
			if (stopped) return;
			if (session && options.check(session)) {
				stopped = true;
				await options.onSuccess(session);
				return;
			}
		} catch {
			// 网络错误静默, 继续轮询
		}
		if (stopped) return;
		if (attempts >= options.config.maxAttempts) {
			stopped = true;
			options.onTimeout();
			return;
		}
		timer = setTimeout(tick, options.config.interval);
	};

	// 首次立即执行, 后续按间隔
	void tick();

	return {
		stop: () => {
			stopped = true;
			if (timer) clearTimeout(timer);
		},
	};
}
